module.exports = __webpack_public_path__ + "static/media/henslerPreview.f4743458.jpg";